import { render, staticRenderFns } from "./IconSvgBulb.vue?vue&type=template&id=4b13fb10&scoped=true&"
import script from "./IconSvgBulb.vue?vue&type=script&lang=js&"
export * from "./IconSvgBulb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13fb10",
  null
  
)

export default component.exports